import { FC, memo } from 'react';
import NextImage from 'next/image';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';

import {
  Content,
  Header,
  BaseDialog as UIBaseDialog,
  Container,
  HeaderContainer,
  Description,
  ImageContainer,
  Title,
} from './baseDialog.styles';
import { BaseDialogProps } from './baseDialog.types';

type RenderContentHeader = (title: string, description: string) => JSX.Element;

const renderContentHeader: RenderContentHeader = (title, description) => (
  <Box>

    <Title>{title}</Title>
    <Description variant="body2">{description}</Description>
  </Box>
);

export const BaseDialog: FC<BaseDialogProps> = memo(
  ({ open, title, description, children, onClose, ...dialogProps }) => {
    const isVisibleContentHeader = !!title || !!description;

    return (
      <UIBaseDialog
        {...dialogProps}
        fullScreen
        fullWidth
        closeAfterTransition
        open={open}
        onClose={onClose}
      >
        <Header component="header">
          <HeaderContainer>
            <NextImage
              src="/svg/SHS-logo.svg"
              alt="Home Stepper logo"
              width={121}
              height={36}
              priority
            />
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </HeaderContainer>
        </Header>
        <Container>
          <Content>
            {isVisibleContentHeader &&
              renderContentHeader(title || '', description || '')}
            {children}
          </Content>
        </Container>
      </UIBaseDialog>
    );
  }
);
